module.exports = __webpack_public_path__ + "static/media/Amelia_Island_FL_History_Museum_Spanish_dock_mural_installed.3af425c9.webp";